import React from 'react';
import PropTypes from 'prop-types';
import { chunk } from 'lodash';
import classnames from 'classnames';
import { Collapsible } from '@fiverr-private/fit';
import classes from './style.module.scss';

const Faq = ({ faqContent, title = '', TitleTag = 'h6', splitColumns = false, className }) => {
    if (!faqContent) {
        return null;
    }

    let faqChunked = [faqContent];
    if (splitColumns) {
        faqChunked = chunk(faqContent, Math.ceil(faqContent.length / 2));
    }

    const faqClasses = classnames(classes.faq, className);
    const colClasses = classnames(classes.columns, {
        [classes.splitColumns]: splitColumns,
    });

    return (
        <div className={faqClasses}>
            {title && <TitleTag className={classes.title}>{title}</TitleTag>}
            <div className={colClasses}>
                {faqChunked.map((faq, index) => (
                    <div className={classes.col} key={index}>
                        {faq.map(
                            ({ question, answer, defaultExpanded }, index) =>
                                question &&
                                answer && (
                                    <Collapsible
                                        key={index}
                                        className="faq-collapsible"
                                        contentClassName="faq-collapsible-content"
                                        titleClassName="faq-collapsible-title"
                                        titleWrapperClassName="faq-collapsible-title-wrapper"
                                        chevronWrapperClassName="faq-collapsible-chevron-wrapper"
                                        title={question}
                                        defaultExpanded={defaultExpanded}
                                    >
                                        <div>{answer}</div>
                                    </Collapsible>
                                )
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

Faq.propTypes = {
    faqContent: PropTypes.arrayOf(
        PropTypes.shape({
            question: PropTypes.string,
            answer: PropTypes.string,
        })
    ),
    title: PropTypes.string,
    splitColumns: PropTypes.bool,
    className: PropTypes.string,
    TitleTag: PropTypes.string,
};

export default Faq;
